import { Typography, Box, styled, Icon, useTheme } from "@mui/material";
import { UpgradeConsumerButton } from "./consumer/UpgradeConsumerButton.js";

const CTAContainer = styled(Box)(
  ({
    theme,
    variant,
    palette = theme.palette,
    overlay = palette.overlay,
    primary = palette.primary,
  }) => ({
    textAlign: "left",
    padding: "32px 24px",
    borderRadius: "24px",
    background:
      variant === "dark"
        ? theme.gradients.ctaDark(theme.palette)
        : theme.gradients.ctaLight(theme.palette),
    border:
      variant === "dark"
        ? `1px solid ${overlay.white15}`
        : `1px solid ${overlay.black04}`,
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background:
        variant === "dark"
          ? theme.gradients.ctaBorderDark(theme.palette)
          : theme.gradients.ctaBorderLight(theme.palette),
    },
  })
);

const PriceContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const UpgradeCTA = ({
  title = "Try Stanza+ for free for 7 days",
  subtitle = "Then just $2.50/month (billed annually)",
  buttonText = "GET STARTED",
  icon = "workspace_premium",
  variant = "light",
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const { primary, secondary, text, overlay } = theme.palette;
  const isDark = variant === "dark";
  return (
    <CTAContainer variant={variant} sx={sx} {...props} theme={theme}>
      <Icon
        baseClassName="material-symbols-outlined"
        sx={{
          display: "block",
          margin: "0",
          marginLeft: "0",
          marginRight: "auto",
          color: isDark ? primary.contrastText : text.primary,
          verticalAlign: "middle",
          fontSize: "2rem",
          mb: 1,
          fontWeight: 300,
          textAlign: "left",
          width: "100%",
        }}
      >
        {icon}
      </Icon>

      <PriceContainer>
        <Typography
          variant="h4"
          sx={{
            fontSize: "1.75rem",
            letterSpacing: "-0.02em",
            marginBottom: 1,
            color: isDark ? primary.contrastText : text.primary,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "1rem",
            fontWeight: 500,
            color: isDark ? overlay.white80 : text.secondary,
            letterSpacing: "-0.01em",
          }}
        >
          {subtitle}
        </Typography>
      </PriceContainer>

      <UpgradeConsumerButton
        sx={{
          borderRadius: "25px",
          px: 4,
          fontWeight: 600,
          textTransform: "none",
          boxShadow: theme.shadows.cardSm(
            theme.palette,
            isDark ? "dark" : "light"
          ),
          ...(isDark && {
            backgroundColor: secondary.main,
            color: secondary.contrastText,
            "&:hover": {
              backgroundColor: overlay.white90,
            },
          }),
        }}
      >
        START YOUR TRIAL
      </UpgradeConsumerButton>
    </CTAContainer>
  );
};
